import { render, staticRenderFns } from "./BopusOnlyFilter.vue?vue&type=template&id=1b0379d9&scoped=true"
import script from "./BopusOnlyFilter.vue?vue&type=script&lang=ts"
export * from "./BopusOnlyFilter.vue?vue&type=script&lang=ts"
import style0 from "./BopusOnlyFilter.vue?vue&type=style&index=0&id=1b0379d9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0379d9",
  null
  
)

export default component.exports